// Calendar planning and email deadlines use Finland's calendar, not the phone's
// current timezone. Date-only deadlines must never shift to the preceding day.
const dateValue=value=>typeof value==="string"&&/^\d{4}-\d{2}-\d{2}$/.test(value)?new Date(`${value}T12:00:00Z`):new Date(value);
export const taskDate=value=>{
  const date=dateValue(value);return value&&Number.isFinite(date.getTime())?new Intl.DateTimeFormat("fi-FI",{timeZone:"Europe/Helsinki",day:"numeric",month:"numeric",year:"numeric"}).format(date):"Ajankohta tuntematon";
};
export const taskTime=value=>{
  const date=dateValue(value);return value&&Number.isFinite(date.getTime())?new Intl.DateTimeFormat("fi-FI",{timeZone:"Europe/Helsinki",hour:"2-digit",minute:"2-digit",hourCycle:"h23"}).format(date):"—";
};
export const taskDeadline=value=>`${taskDate(value)}${typeof value==="string"&&value.includes("T")?` klo ${taskTime(value)} (Suomen aika)`:""}`;
export const taskDateInput=value=>{
  if(!value)return "";
  const parts=new Intl.DateTimeFormat("en-CA",{timeZone:"Europe/Helsinki",year:"numeric",month:"2-digit",day:"2-digit"}).formatToParts(dateValue(value));
  const get=key=>parts.find(part=>part.type===key).value;
  return `${get("year")}-${get("month")}-${get("day")}`;
};
export const taskTimeInput=value=>value&&value.includes("T")?taskTime(value).replace(".",":"):"";
export const taskDay=value=>{
  if(!value)return null;const date=dateValue(value);if(!Number.isFinite(date.getTime()))return null;
  const parts=new Intl.DateTimeFormat("en-CA",{timeZone:"Europe/Helsinki",year:"numeric",month:"2-digit",day:"2-digit"}).formatToParts(date);
  const get=key=>Number(parts.find(part=>part.type===key).value);
  return Date.UTC(get("year"),get("month")-1,get("day"));
};
